import * as React from 'react';

import { SliderItem, GetHandleProps } from 'react-compound-slider';

import styled from 'styled-components';

interface HandleProps {
  className?: string;
  domain: number[];
  handle: SliderItem;
  getHandleProps: GetHandleProps;
  trackWidth: number;
  songLength: number;
}

const getHandlePosition = (
  total: number,
  percent: number,
  handleWidth: number
) => {
  let result = ((total - handleWidth) * percent) / 100;

  if (result < 0) {
    result = 0;
  }

  return `${result}px`;
};

const getHandleWidth = (totalLength: number, sliderWidth: number) => {
  const width = Math.ceil(sliderWidth / totalLength);

  if (width < 0) {
    return 0;
  }

  if (width > sliderWidth) {
    return sliderWidth;
  }

  return width;
};

export const Handle: React.FC<HandleProps> = ({
  domain: [min, max],
  handle: { id, value, percent },
  getHandleProps,
  className,
  trackWidth,
  songLength,
}) => {
  return (
    <>
      <div
        className={className}
        role="slider"
        aria-valuemin={min}
        aria-valuemax={max}
        aria-valuenow={value}
        style={{
          left: getHandlePosition(
            trackWidth,
            percent,
            getHandleWidth(songLength, trackWidth)
          ),
          zIndex: 2,
          width: '13px',
          height: '13px',
          cursor: 'pointer',
          background: 'white',
          border: '3px solid #086EE5',
          borderRadius: '10px',
        }}
        {...getHandleProps(id)}
      />
    </>
  );
};

export default styled(Handle)`
  position: absolute;
  top: 50%;
  z-index: 2;
  min-width: 5px;
  max-width: 100%;
  height: 3px;
  cursor: grab;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.blueColor};
  transform: translate(0, -50%);
`;
